module.exports = __webpack_public_path__ + "img/computer-man-stock-img.3380ad4e.jpeg";